import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react"
import { NavLink } from "react-router-dom"
import "./styles/nav.css"
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline"

export default function Nav({ open, setOpen }) {
  return (
    <Disclosure
      as="nav"
      className="bg-[#0e0e16] shadow-sm sticky top-0 z-50 nav-blur "
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <div className="-ml-2 mr-2 flex items-center md:hidden">
              {/* Mobile menu button */}
              <DisclosureButton className="group relative inline-flex items-center justify-center rounded-md p-2 bg-[#0a0a10] border border-[#1e1e2e] text-[#eeeeff] focus:outline-none ">
                <span className="absolute -inset-0.5" />
                <span className="sr-only">Open main menu</span>
                <Bars3Icon
                  aria-hidden="true"
                  className="block h-6 w-6 group-data-[open]:hidden"
                />
                <XMarkIcon
                  aria-hidden="true"
                  className="hidden h-6 w-6 group-data-[open]:block"
                />
              </DisclosureButton>
            </div>
            <NavLink to="/" className="flex-col flex-shrink-0 text-left">
              <div className="text-2xl text-[#eeeeff]">Sara Wasim</div>
              <div className="text-xs text-gray-500">
                FULL STACK WEB DEVELOPER & UI/UX DESIGNER
              </div>
            </NavLink>
          <div className="flex-shrink-0">
            <div className="hidden md:flex md:space-x-8">
              <NavLink
                to="/"
                className={({ isActive }) => {
                  return isActive
                    ? "inline-flex items-center px-1 pt-1 text-sm  text-[#eeeeff] font-semibold"
                    : "inline-flex items-center border-transparent px-1 pt-1 text-sm  text-gray-500 hover:text-gray-700"
                }}
              >
                PROJECTS
              </NavLink>
              <NavLink
                to="/timeline"
                className={({ isActive }) => {
                  return isActive
                    ? "inline-flex items-center px-1 pt-1 text-sm  text-[#eeeeff] font-semibold"
                    : "inline-flex items-center border-transparent px-1 pt-1 text-sm  text-gray-500 hover:text-gray-700"
                }}
              >
                TIMELINE
              </NavLink>
              <div
                className="inline-flex items-center border-transparent px-1 pt-1 text-sm  text-gray-500 hover:text-gray-700 cursor-pointer"
                onClick={() => setOpen(!open)}
              >
                RESUME
              </div>
            </div>
          </div>
        </div>
      </div>

      <DisclosurePanel className="md:hidden bg-[#0a0a10]">
        <div className="space-y-1 pb-3 pt-2">
          <NavLink
            to="/"
            className={({ isActive }) => {
              return isActive
                ? "block border-l-4 border-black bg-black py-2 pl-3 pr-4 text-sm  text-[#eeeeff] sm:pl-5 sm:pr-6"
                : "block border-l-4 border-transparent py-2 pl-3 pr-4 text-sm  text-gray-500 sm:pl-5 sm:pr-6"
            }}
          >
            PROJECTS
          </NavLink>
          <NavLink
            to="/timeline"
            className={({ isActive }) => {
              return isActive
                ? "block border-l-4 border-black bg-black py-2 pl-3 pr-4 text-sm  text-[#eeeeff] sm:pl-5 sm:pr-6"
                : "block border-l-4 border-transparent py-2 pl-3 pr-4 text-sm  text-gray-500 sm:pl-5 sm:pr-6"
            }}
          >
            TIMELINE
          </NavLink>
          <DisclosureButton
            as="a"
            href="assets/saraWasimResume.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="block border-l-4 border-transparent py-2 pl-3 pr-4 text-sm  text-gray-500 hover:text-gray-700  hover:border-gray-300 hover:bg-gray-50 sm:pl-5 sm:pr-6"
          >
            RESUME
          </DisclosureButton>
        </div>
      </DisclosurePanel>
    </Disclosure>
  )
}
